import { IDocumentAction } from './actions';
import { IDocumentsApplicationState } from './interfaces';
import { DocumentUploadReducer } from './upload/DocumentUploadReducer';
import { DocumentEditReducer } from './edit/DocumentEditReducer';
import { DocumentSharedReducer } from './shared/DocumentSharedReducer';

export const DocumentsReducer = (
  oldState: IDocumentsApplicationState,
  action: IDocumentAction
): IDocumentsApplicationState => {
  switch (action.type) {
    case 'SetSharedStandardDocuments':
      return { ...oldState, shared: DocumentSharedReducer(oldState.shared, action) };
    case 'SetUploadIsLoading':
    case 'SetUploadIsComplete':
    case 'SetUploadHasError':
    case 'DeleteUploadDocument':
    case 'SetUploadDocuments':
    case 'SetUploadDocument':
    case 'SetUploadDocumentCategory':
    case 'SetUploadDocumentMetadata':
      return { ...oldState, upload: DocumentUploadReducer(oldState.upload, action) };
    case 'SetEditResetModal':
    case 'SetEditShowModal':
    case 'SetEditIsLoading':
    case 'SetEditDocument':
      return { ...oldState, edit: DocumentEditReducer(oldState.edit, action) };
  }
};
